import * as React from 'react';
import { useTranslation } from './useTranslation';

const KEY_ALIAS: Record<string, string> = {
  pdf: 'productsheet',
};

export function useItemLabel() {
  const { t } = useTranslation();

  return React.useCallback(
    (icon: string | undefined, fallbackTitle: string): string => {
      return icon
        ? t(`herotext.${KEY_ALIAS[icon] ?? icon}`, fallbackTitle)
        : fallbackTitle;
    },
    [t],
  );
}
